import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'kd-document-text',
    templateUrl: './document-text.component.html',
    styleUrls: ['./document-text.component.scss']
})
export class DocumentTextComponent implements OnInit {

    @Input()
    content: HTMLElement;

    constructor() { }

    ngOnInit() {
    }
}
